import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const InfoToast = ({ show, message, type, onClose }) => {
  return (
    <Snackbar
      open={show}
      autoHideDuration={2500}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        zIndex: 10000,
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: '5%',
      }}
    >
      <Alert onClose={onClose} severity={type} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default InfoToast;
